enum UserRole {
  Teacher = 'teacher',
  Student = 'student',
  Public = 'public',
}

export { UserRole }
